export const DOM = {

  // Desabilita os elementos quando houver um request (ajax) pendente
  // (d)isable (w)hen (r)equesting
  dwr (disable) {
    $('.asf-dwr').prop('disabled', disable);
    $('.asf-cswr').removeClass('show');
    if (disable) $('.asf-cswr').addClass('show');
  }

};